import { BlurView } from "expo-blur";
import React from "react";
import { ActivityIndicator, Modal, Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import WebView from "react-native-webview";
import { Box, AHText, AHButton, TouchableBox } from "arkh";
import Constants from "expo-constants";

import { FormattedMessage } from "react-intl";
import { reloadAsync, useUpdates } from "expo-updates";

export function UpdateModal(props: { onDismiss: () => void }) {
  const insets = useSafeAreaInsets();
  const updates = useUpdates();

  return (
    <Modal presentationStyle="pageSheet">
      {Platform.OS === "web" ? (
        <iframe
          src="https://www.storesprint.com/support/direct/team-schedule-find-create"
          style={{ width: "100%", height: "100%" }}
        />
      ) : (
        <WebView
          source={{
            uri: `https://storesprint.com/in-app-update/?v=${Constants.nativeBuildVersion}`,
          }}
          automaticallyAdjustContentInsets
          automaticallyAdjustsScrollIndicatorInsets
          contentInset={{ bottom: 100 }}
          decelerationRate={Platform.OS === "ios" ? "normal" : undefined}
          containerStyle={{
            paddingBottom: Platform.OS === "ios" ? insets.bottom : 0,
          }}
        />
      )}

      <BlurView
        intensity={100}
        tint="light"
        style={{
          paddingBottom: insets.bottom,
          position: "absolute",
          left: 0,
          bottom: 0,
          right: 0,
        }}
      >
        <Box
          style={{
            height: 100,
          }}
        >
          <Box
            spaceHorizontal="medium"
            style={{
              justifyContent: "flex-end",
            }}
          >
            <Box style={{ height: 80, justifyContent: "center" }}>
              {!updates.isUpdatePending ? (
                <Box
                  style={{
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <AHText spaceRight="medium" type="subtitle">
                    <FormattedMessage
                      defaultMessage="Donwloading Update"
                      description="UpdateModal:DownloadingUpdateView:label"
                    />
                  </AHText>
                  <Box>
                    <ActivityIndicator size="small" animating />
                  </Box>
                </Box>
              ) : (
                <Box spaceHorizontal="medium">
                  <AHButton
                    themeType="primary"
                    title="Update"
                    onPress={() => {
                      reloadAsync();
                    }}
                  />
                </Box>
              )}
            </Box>
            <TouchableBox
              onPress={() => {
                props.onDismiss();
              }}
            >
              <AHText style={{ textAlign: "center" }} type="body">
                <FormattedMessage
                  defaultMessage="Skip"
                  description="UpdateModal:DismissButton:title"
                />
              </AHText>
            </TouchableBox>
          </Box>
        </Box>
      </BlurView>
    </Modal>
  );
}
